module.exports = __webpack_public_path__ + "static/media/shipments_icon_dark.387be3a8.png";